/**
 * @namespace constants
 */

/**
 * @constant
 * @memberof constants
 * @type {string[]}
 */
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Value for {@link AdaptiveCard#sendCard} to use to determine which method to
 * use and how to modify the request data.
 * @constant
 * @memberof constants
 * @type {string}
 */
export const TEAMS_SEARCH_PEOPLE = 'People';

/**
 * Value for {@link AdaptiveCard#sendCard} to use to determine which method to
 * use and how to modify the request data.
 * @constant
 * @memberof constants
 * @type {string}
 */
export const TEAMS_SEARCH_CHANNEL = 'Teams/Channels';

/**
 * Value for {@link OmniTeamsSelectionModal} to use for filtering results
 * @constant
 * @memberof constants
 * @type {number}
 * @see {@link OmniTeamsSelectionModal#onCategoryChange}
 */
export const TEAMS_SEARCH_ALL_CATEGORIES = 'All categories';

/**
 * The delay in milliseconds used by {@link OmniTeamsSelectionModal} for input handler debouncing
 * @constant
 * @memberof constants
 * @type {number}
 * @see {@link OmniTeamsSelectionModal#firstUpdated}
 */
export const INPUT_DEBOUNCE_TIMER = 1000;

/**
 * Options for {@link OmniTeamsSelectionModal} results filtering
 * @constant
 * @type {string[]}
 * @see {@link OmniTeamsSelectionModal#renderRecipients}
 * @see {@link OmniTeamsSelectionModal#onCategoryChange}
 */
export const CATEGORY_OPTIONS = [TEAMS_SEARCH_PEOPLE, TEAMS_SEARCH_CHANNEL];

export const CATEGORY_TO_ABBREVIATION = {
  [TEAMS_SEARCH_PEOPLE]: TEAMS_SEARCH_PEOPLE,
  [TEAMS_SEARCH_CHANNEL]: 'Teams',
};

// "visible" is used to hide/unhide results in the menu
export const INTIAL_STATE_SEARCH_RESULTS = [
  { type: TEAMS_SEARCH_PEOPLE, options: [], visible: true },
  { type: TEAMS_SEARCH_CHANNEL, options: [], visible: true },
];
